// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2VG39","info":"UpdateTermsInfo_info__QwTl8"};